// RU: звук игры. Звуков джекпота и колеса (boosted jackpot) нет: джекпот — слой платформы.
//     `AmountIncrease` (счёт суммы Big Win) и `MaxWinSound` (тир MAX) играет ядро.
const sound = (name, file, options = {}) => ({
  src: `game/sounds/${file}.mp3`,
  path: `game/sounds/${file}.mp3`,
  name,
  autoplay: false,
  html5: true,
  ...options,
});

export const soundResources = [
  sound('ReelStop', 'reelStop'),
  sound('ScatterWin1', 'scatter1Win'),
  sound('ScatterWin2', 'scatter2Win'),
  sound('SpinButton', 'spinButton'),
  sound('WildSymbol', 'wildSymbol'),
  sound('WildOpeningSound', 'wildOpeningSound'),
  sound('WinningLineSound', 'winningLineSound'),
  sound('AmountIncrease', 'amountIncrease'),
  sound('BigWinSound', 'bigWinSound'),
  sound('MegaWinSound', 'megaWinSound'),
  sound('SuperWinSound', 'superWinSound'),
  sound('EpicWinSound', 'epicWinSound'),
  sound('MaxWinSound', 'maxWinSound'),
  sound('BackgroundMusic', 'backgroundMusic', { autoplay: true, loop: true }),
];
